/**
 * SectionDivider — discrete inter-section visual cue.
 * Two soft lines converging to a small Aurora-gradient dot with a halo.
 * Used between Home sections to add rhythm without bruit.
 */
export default function SectionDivider({ className = "" }) {
  return (
    <div
      aria-hidden="true"
      data-testid="section-divider"
      className={`mx-auto max-w-7xl px-6 md:px-10 flex items-center gap-4 ${className}`}
    >
      <span
        className="flex-1 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(11,16,39,0.15) 50%, rgba(11,16,39,0.15) 100%)",
        }}
      />
      <span
        className="h-2.5 w-2.5 rounded-full shrink-0"
        style={{
          background:
            "linear-gradient(135deg, #6366F1 0%, #A855F7 50%, #EC4899 100%)",
          boxShadow: "0 0 14px rgba(168, 85, 247, 0.45)",
        }}
      />
      <span
        className="flex-1 h-px"
        style={{
          background:
            "linear-gradient(90deg, rgba(11,16,39,0.15) 0%, rgba(11,16,39,0.15) 50%, transparent 100%)",
        }}
      />
    </div>
  );
}
